import { useUserStore } from 'src/store/User/user_details.store';
import { SessionStorage, LocalStorage } from 'quasar';

export function getOrgId() {
  // CRITICAL FIX: Check SessionStorage FIRST (survives clearAllStorage during login flow)
  // SessionStorage is set by authSdkService.setSessionUser() and protected from clearAllStorage
  // This ensures org_id is available immediately after login, even if LocalStorage is temporarily cleared

  // Try Quasar's SessionStorage wrapper first
  let sessionOrgId = SessionStorage.getItem('active_org_id') as string | null;

  // BUGFIX: If Quasar wrapper returns null, try native sessionStorage
  // This handles cases where Quasar's wrapper has issues
  if (!sessionOrgId && typeof window !== 'undefined' && window.sessionStorage) {
    sessionOrgId = window.sessionStorage.getItem('active_org_id');
  }

  if (sessionOrgId) {
    return sessionOrgId.replace(/\s/g, '');
  }

  // Fallback to LocalStorage via user store (for persistence across sessions if needed)
  const user_store = useUserStore();
  const org_id = user_store.getOrgId();

  if (org_id) {
    return org_id.replace(/\s/g, '');
  }

  // Only warn if user is authenticated (has a token) - rate limited to once per minute
  // Check for window existence (not available in Node.js test environments)
  if (process.env.DEV && typeof window !== 'undefined') {
    const now = Date.now();
    const lastWarn = (window as any).__orgIdHelperLastWarn || 0;
    if (now - lastWarn > 60000) {
      const tokenDetails = LocalStorage.getItem('token_details') as any; // Note: typo is intentional
      const isAuthenticated = tokenDetails?.access_token;
      if (isAuthenticated) {
        console.warn('[ORG_ID_HELPER] No org_id found in SessionStorage or user store');
        (window as any).__orgIdHelperLastWarn = now;
      }
    }
  }

  return org_id;
}

export function hasValidOrgId(): boolean {
  const org_id = getOrgId();
  return !!(
    org_id &&
    org_id.trim() !== '' &&
    org_id !== 'null' &&
    org_id !== 'undefined'
  );
}

export function addOrgIdToUrl(url: string) {
  const org_id = getOrgId();
  if (org_id) {
    url = url.replace('{org_id}', org_id);
  }
  return url;
}

export function addOrgIdQueryString(url: string) {
  const org_id = getOrgId();
  if (!org_id) {
    return url;
  }

  const orgIdRegex = /[?&]org_id=[^&]*/;
  const match = orgIdRegex.exec(url);

  if (match !== null) {
    return url;
  } else if (url.includes('?')) {
    return url + '&org_id=' + org_id;
  } else {
    return url + '?org_id=' + org_id;
  }
}
